/** @jsx React.DOM */
'use strict';

// Require Object.assign polyfill to use JSX Spread Attributes syntax
// See https://gist.github.com/sebmarkbage/07bbe37bc42b6d4aef81
require('./Object.es6');

var React = require('react'),
    $__0=       require('react-router'),Routes=$__0.Routes,Route=$__0.Route,Redirect=$__0.Redirect,Link=$__0.Link,
    DragAroundNaive = require('./_drag-around-naive/index'),
    DragAroundCustom = require('./_drag-around-custom/index'),
    DustbinSimple = require('./_dustbin-simple'),
    DustbinInteresting = require('./_dustbin-interesting'),
    SortableSimple = require('./_sortable-simple');

var App = React.createClass({displayName: 'App',
  render:function() {
    return (
      React.createElement("div", null, 
        React.createElement("h1", null, "react-dnd examples (", React.createElement("a", {target: "_href", href: "https://github.com/gaearon/react-dnd/blob/master/examples"}, "source"), ")"), 
        React.createElement("ul", null, 
          React.createElement("li", null, "Dustbin (", React.createElement(Link, {to: "dustbin-simple"}, "simple"), ", ", React.createElement(Link, {to: "dustbin-interesting"}, "interesting"), ")"), 
          React.createElement("li", null, "Drag Around (", React.createElement(Link, {to: "drag-around-naive"}, "naive"), ", ", React.createElement(Link, {to: "drag-around-custom"}, "custom"), ")"), 
          React.createElement("li", null, "Sortable (", React.createElement(Link, {to: "sortable-simple"}, "simple"), ", more coming...)")
        ), 
        React.createElement("hr", null), 
        React.createElement(this.props.activeRouteHandler, null)
      )
    );
  }
});

var routes = (
  React.createElement(Routes, {location: process.env.NODE_ENV === 'production' ? 'hash' : 'history'}, 
    React.createElement(Route, {handler: App}, 
      React.createElement(Route, {name: "drag-around-naive", path: "drag-around-naive", handler: DragAroundNaive}), 
      React.createElement(Route, {name: "drag-around-custom", path: "drag-around-custom", handler: DragAroundCustom}), 
      React.createElement(Route, {name: "dustbin-simple", path: "dustbin-simple", handler: DustbinSimple}), 
      React.createElement(Route, {name: "dustbin-interesting", path: "dustbin-interesting", handler: DustbinInteresting}), 
      React.createElement(Route, {name: "sortable-simple", path: "sortable-simple", handler: SortableSimple}), 

      React.createElement(Redirect, {from: "/", to: "dustbin-simple"})
    )
  )
);

React.renderComponent(routes, document.body);


/*****************
 ** WEBPACK FOOTER
 ** ./index.js
 ** module id = 0
 ** module chunks = 0
 **/